import React from 'react';
import { NavLink } from 'react-router-dom';
import { translate } from 'react-i18next';

import NewsletterHeader from './NewsletterHeader';

const UserUpdatesHeader = ({
  nextUpdate,
  daysToNextUpdate,
  t,
  title,
  subtitle,
}) => (
  <React.Fragment>
    <NewsletterHeader
      title={title}
      subtitle={subtitle}
      nextUpdate={nextUpdate}
      daysToNextUpdate={daysToNextUpdate}
    />
    {/* Tabs */}
    <div className="c-tabs">
      <div className="o-wrapper o-wrapper--small">
        <nav className="c-tabs-nav u-text-center u-display-flex">
          <NavLink
            activeClassName="is-active"
            to="/updates/last"
            className="u-padding c-tabs-nav__link c-tabs-nav__link"
          >
            {t('manageUpdates.currentUpdatesTab')}
          </NavLink>
          <NavLink
            activeClassName="is-active"
            to="/updates/confirm"
            className="u-padding c-tabs-nav__link"
          >
            {t('manageUpdates.confirmTab')}
            <div>
              <small>
                {daysToNextUpdate < 8
                  ? t('manageUpdates.confirmTabNoteActive')
                  : t('manageUpdates.confirmTabNote', {
                      count: daysToNextUpdate - 7,
                      postProcess: 'interval',
                    })}
              </small>
            </div>
          </NavLink>
        </nav>
      </div>
    </div>
  </React.Fragment>
);

export default translate()(UserUpdatesHeader);



// WEBPACK FOOTER //
// ./src/common/UserUpdatesHeader.js